module.exports = __webpack_public_path__ + "static/media/cdn.b945d726.svg";